export const blockIconsToggleStarPurple500 = (
	<span className='material-symbols-outlined'>star_purple500</span>
);
